import { ToolboxStreamfield } from "components/wagtail/Toolbox";
import { StreamfieldBlock } from "interfaces";

export interface ResuableContentCmsData {
    content: any;
}

export type ResuableContentBlock = StreamfieldBlock<
    "reusable_content",
    ResuableContentCmsData
>;

export const ResuableContentBlock = (props: ResuableContentCmsData) => {
    return <ToolboxStreamfield blocks={props.content} />;
};
